import { z } from 'zod';
const objectId = z.string().min(1).max(64);
export const gameJoinSchema = z.object({ objectId });
export const gameSitSchema = z.object({ objectId, seat: z.enum(['w', 'b']) });
export const gameLeaveSchema = z.object({ objectId });
export const gameMoveSchema = z.object({ objectId, move: z.string().min(1).max(8) });
export const gameResetSchema = z.object({ objectId });
//# sourceMappingURL=gameSchema.js.map